import React from "react";
import Header from "../Header/Header";
import { connect } from "react-redux";
import GameInformationExp from "../Header/GameInformation/GameInformationExp";
import AppCSS from "../../assets/app/AppCSS";
import AppJS from "../../assets/app/AppJS";
function MainHeader(props) {
  return (
    <>
      <AppJS/>
      <AppCSS/>
      {/* {props.isAdmin ? ( */}
      <GameInformationExp
        view_selected={props.game_information_info.view_selected}
        userEmail={props.userEmail}
        isAdmin={props.isAdmin}
      />
      {/* ) : (
        <GameInformation
          view_selected={props.game_information_info.view_selected}
          userEmail={props.userEmail}
        />
      )} */}
      <Header view_selected={props.game_information_info.view_selected} />
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    game_information_info: state,
  };
};

export default connect(mapStateToProps)(MainHeader);
